var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C23.2843 0 30 6.71574 30 15C30 23.2843 23.2843 30 15 30C6.71574 30 0 23.2843 0 15C0 6.71574 6.71574 0 15 0Z",
    fill: "url(#paint0_linear_95_4690)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.949 29.8741V18.2878H20.2154L20.6484 14.21H16.949L16.9545 12.1689C16.9545 11.1053 17.0555 10.5357 18.5832 10.5357H20.6255V6.45715H17.3583C13.4339 6.45715 12.0529 8.43523 12.0529 11.7622V14.2103H9.60654V18.2885H12.0529V29.7098C13.0059 29.8997 13.9912 30 15 30C15.6517 30 16.3027 29.958 16.949 29.8741Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_4690",
    x1: 15,
    y1: -0.273315,
    x2: 15,
    y2: 31.2792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b578a7eccc6c2a6819b2fd145882daeb.svg";
export { ForwardRef as ReactComponent };